export default {
  iosSetupUrl: 'https://itunes.apple.com/cn/app/wei-shi-8miao-duan-shi-pin/id691828408?mt=8',

  APPID: 1101083114,
  PACKAGE_NAME: 'com.tencent.weishi',
  // 需要用ars发布的旧链接
  // SUPER_DOWNLOAD: 'https://qzonestyle.gtimg.cn/wesee/superdownload/dist/index.js?t=now',
  SUPER_DOWNLOAD: 'https://isee.weishi.qq.com/superdownload/index.js',

  androidPackageCfg: {
    'qzone.hot': 3665, // 好友热播
    'qzone.talent': 3666, // 达人同步到空间
    discovery: 3667, // 独立版微视tab
    unknown: 3684, //
  },
  androidPackageClientCfg: {
    qq: '027002000',
    qzone: '027003000',
    wx: '027000000',
    wb: '027004000',
  },
};
